import { render, staticRenderFns } from "./edit-series.vue?vue&type=template&id=ba6ac530"
import script from "./edit-series.vue?vue&type=script&lang=js"
export * from "./edit-series.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports